import { BucketedMonthlyHomeExpenses } from '../../../../../api/gqlaxy/gql/generated/graphql'

export interface calculateAssumableSavingsProps {
  assumableBucketedMonthlyHomeExpenses: BucketedMonthlyHomeExpenses
  bucketedMonthlyHomeExpenses: BucketedMonthlyHomeExpenses
}

export const calculateAssumableSavings = ({
  assumableBucketedMonthlyHomeExpenses,
  bucketedMonthlyHomeExpenses
}: calculateAssumableSavingsProps): number | null => {
  // if either of the monthly payments are null, return 0 to avoid incorrect savings calculation

  const traditionalMonthlyPayment = bucketedMonthlyHomeExpenses?.totalMonthlyHomeExpenses
  const assumableMonthlyPayment = assumableBucketedMonthlyHomeExpenses?.totalMonthlyHomeExpenses

  if (!traditionalMonthlyPayment || !assumableMonthlyPayment) {
    return null
  }

  return traditionalMonthlyPayment - assumableMonthlyPayment
}
